// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Ga1Sn","rootNoMargin":"styles_rootNoMargin__1loID"};